import { Component } from '@angular/core';

@Component({
  selector: 'app-riskmanage',
  templateUrl: './riskmanage.component.html',
  styleUrls: ['./riskmanage.component.css']
})
export class RiskmanageComponent {
ShowCard:any;
}
